import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Login from "../Login/Login";
import Cookies from 'js-cookie';
import './App.css';
import Inventario from "../Inventario/Inventario";
import Carrito from "../Carrito/Carrito";
import Pedidos from "../Pedidos/Pedidos";
import Servicios from "../Servicios/Servicios";
import CitaForm from "../Servicios/HacerCitas";
import OrdenServicioCentroCamionero from "../Servicios/CCformulario";
import OrdenServicioUnidadMovil from "../Servicios/Uniformulario";
import OrdenVitalizado from "../Servicios/OrdenVitalizado";
import ProductoNegado from "../productonegado/ProductoNegado";
import ReactGA from "react-ga4";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return null;
}

const PrivateRoute = ({ children }) => {
  const token = Cookies.get('authToken');
  return token ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router basename="/camion">
      <AnalyticsTracker />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Login />} />

        <Route path="/inventario" element={
          <PrivateRoute>
            <Inventario />
          </PrivateRoute>
        } />

        <Route path="/servicios" element={
          <PrivateRoute>
            <Servicios />
          </PrivateRoute>
        } />

        <Route path="/carrito" element={
          <PrivateRoute>
            <Carrito />
          </PrivateRoute>
        } />

        <Route path="/pedidos" element={
          <PrivateRoute>
            <Pedidos />
          </PrivateRoute>
        } />
        <Route path="/agendar" element={
          <PrivateRoute>
            <CitaForm />
          </PrivateRoute>
        } />
        <Route path="/orden-CC/:idCita" element={
          <PrivateRoute>
            <OrdenServicioCentroCamionero/>
          </PrivateRoute>
        } />
        <Route path="/orden-UnidadMovil/:idCita" element={
          <PrivateRoute>
            <OrdenServicioUnidadMovil/>
          </PrivateRoute>
        } />
        <Route path="/orden-Vitalizado/:idCita" element={
          <PrivateRoute>
            <OrdenVitalizado/>
          </PrivateRoute>
        } />
        <Route path="/productonegado" element={
          <PrivateRoute>
            <ProductoNegado />
          </PrivateRoute>
        } />
      </Routes>
    </Router>
  );
}

export default App;
